import React from "react";
export default ({ onCancel, financialProvider }) => (React.createElement("div", { "data-ecom-frame": true },
    React.createElement("div", { className: "frame-body" },
        React.createElement("div", { "data-ecom-page": "justify-center", className: "text-center" },
            React.createElement("section", { className: "page-section" },
                React.createElement("h1", { className: "h6" },
                    "V\u00E4ntar p\u00E5 ",
                    financialProvider,
                    "..."),
                React.createElement("div", { "data-ecom-content": true },
                    React.createElement("p", null,
                        "H\u00E4mtar uppgifter fr\u00E5n ",
                        financialProvider,
                        ". V\u00E4nta kvar d\u00E5 det kan ta n\u00E5gra sekunder."))),
            React.createElement("section", { className: "page-section" },
                React.createElement("div", { "data-ecom-spinner": "center third-party" },
                    React.createElement("div", { className: "spinner" }))),
            React.createElement("section", { className: "page-section" },
                React.createElement("button", { "data-ecom-link": true, onClick: onCancel }, "Avbryt"))))));
